// generated by genversion
export var version = '3.8.3';
//# sourceMappingURL=version.js.map